// @flow
import React from 'react'
import icons, { SVGElement } from './icon-list'

type IconProps = {
  icon: 'NavMenu' | 'UIDropdown' | 'UIFilter',
  fill?: any,
  width: number,
  height: number,
}

const Icon = (props: IconProps) => {
  const { icon, fill = 'black', width = 10, height = 10 } = props
  const haveSVG = icons.hasOwnProperty(icon)
  const svg: SVGElement | null = haveSVG ? icons[icon] : null

  if (!svg) {
    return null
  }

  return (
    <svg width={width} height={height} viewBox={svg.viewbox}>
      <g fill={fill}>
        {svg.paths ? <path d={svg.paths} /> : null}
        {svg.points ? <polygon points={svg.points} /> : null}
      </g>
    </svg>
  )
}

export default Icon
